import React, { useEffect, useRef, useState } from "react";
import styles from "./event.module.css";
import { useNavigate } from "react-router-dom";
import ContainerOptions from "common/ContainerOptions";
import ContainerHeader from "common/ContainerHeader";
import { getAll } from "utils/queries";
import { debounce, formatDateFromDateAndTime } from "utils";
import dayjs from "dayjs";
import Tabs_ from "common/Tabs";
import DataTable_ from "common/DataTable";
import Badge from "common/Badge";

const Event = () => {
  const [data, setData] = useState();
  const [totalCount, setTotalCount] = useState();
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const navigate = useNavigate();
  const childRef = useRef();

  const TabList = [
    { label: "Upcoming Events", value: "upcoming" },
    { label: "Past Events", value: "past" },
  ];

  const columns = [
    {
      name: "Event  Name",
      cell: (row) => (
        <div
          className={styles.eventName}
          onClick={() => navigate(`./event-details/${row?.id}`)}
        >
          {" "}
          {row.event_name}{" "}
        </div>
      ),
    },
    // { name: "Status ", selector: (row) => row.status },
    {
      name: "Status",
      cell: (row) => {
        const bgColor = "#0000000F";
        const color = "#616161";
        return <Badge style={{ background: bgColor }} label={row.status} />;
      },
    },
    // { name: "Location ", selector: (row) => row.location },
    { name: "Venue ", selector: (row) => row.venue },
    {
      name: "Start date ",
      selector: (row) => formatDateFromDateAndTime(row.starts),
    },
    {
      name: "End date ",
      selector: (row) => formatDateFromDateAndTime(row.ends),
    },
    {
      name: "Last Entry Time",
      selector: (row) => formatDateFromDateAndTime(row.last_entry_time),
    },
    {
      name: "",
      selector: (row) => {
        let bgColor;

        if (row?.status == "active" || row?.status == "published") {
          bgColor = "var(--primary-color)";
        }
        if (row?.status == "draft") {
          bgColor = "orange";
        }
        if (row?.status == "scheduled") {
          bgColor = "green";
        }

        // if(row?.status=="publish")

        return (
          <Badge
            style={{ background: bgColor, color: "white" }}
            label={row?.status}
          />
        );
      },
    },
  ];

  const resetFields = () => {
    childRef.current.resetFields();
  };

  const fetchAllEvents = async ({
    index = selectedTabIndex,
    limit = 10,
    offset = 0,
    search = null,
    currentDate = dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    pastDate = null,
  }) => {
    try {
      let query = `event/events?eventType=${TabList[index]?.value?.trim()}
        &currentDate=${currentDate}&limit=${limit}&offset=${offset}`;

      if (pastDate) {
        query += `&pastDate=${pastDate}`;
      }

      if (search) {
        query += `&search=${search}`;
      }

      const result = await getAll(query);

      const Data = result?.data?.data;
      if (Data?.rows) {
        setData(Data?.rows);
        setTotalCount(Data?.totalCount);
      }
    } catch (error) {}
  };

  const searchDebounce = debounce(
    (searchTerm) =>
      fetchAllEvents({ limit: 10, offset: 0, search: searchTerm }),
    1000
  );
  const containerOptions = [
    {
      label: "Search",
      icon: "search",
      position: "pre",
      type: "search",
      handleOnChange: (e) => {
        resetFields();
        searchDebounce(e?.target?.value);
      },
    },
    {
      label: "Last 7 Days",
      icon: "calendar",
      position: "pre",
      type: "button",
      style: {
        width: "100%",
      },
      onClick: () => {
        const currentDate = dayjs();
        const past7thDate = currentDate.subtract(7, "day");

        fetchAllEvents({ limit: 10, offset: 0, pastDate: past7thDate });
      },
    },
  ];

  const handleChangeIndex = (index) => {
    setSelectedTabIndex(index);
    fetchAllEvents({ index });
  };

  useEffect(() => {
    fetchAllEvents({ selectedTabIndex });
  }, []);

  return (
    <>
      <div className={styles.container}>
        <ContainerHeader
          label="Your Events"
          buttonLabel="Create Event"
          buttonFunction={() => {
            navigate(`./create-event`);
          }}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "20px",
            marginTop: "10px",
            marginBottom: "0px",
          }}
        >
          <ContainerOptions Fields={containerOptions} />
        </div>

        <Tabs_
          selectedIndex={selectedTabIndex}
          setSelectedIndex={(e) => handleChangeIndex(e)}
          TabList_={TabList}
          TabContent_={[
            {
              content: (
                <DataTable_
                  handlefetchData={fetchAllEvents}
                  data={data}
                  totalCount={totalCount}
                  columns={columns}
                  ref={childRef}
                />
              ),
            },
            {
              content: (
                <DataTable_
                  handlefetchData={fetchAllEvents}
                  data={data}
                  totalCount={totalCount}
                  columns={columns}
                  ref={childRef}
                />
              ),
            },
          ]}
        />
      </div>
    </>
  );
};

export default Event;
